"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MESSAGE_CHANNELS = void 0;
var MESSAGE_CHANNELS = exports.MESSAGE_CHANNELS = ['email', 'push', 'sms', 'websocket'];